import React from "react";

export const ButtonLoadingIcon = () => {
  return (
    <span className="spinner d-inline-block">
      <span className="bounce1" />
      <span className="bounce2" />
      <span className="bounce3" />
    </span>
  );
};
